import { APITransport } from '@client/transports/api';

const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

export const FontsService = {
  getFonts() {
    return APITransport.get({
      path: 'https://www.googleapis.com/webfonts/v1/webfonts',
      query: {
        key: GOOGLE_API_KEY,
        subset: 'latin'
      }
    });
  }
};
